const quickbooksDesktopEndpoints = {
  SYNC_LOG: "sync-log/",
  MARK_SYNCED: "mark-synced/",
  MARK_NOT_SYNCED: "mark-not-synced/",
  CLEAR_TICKET: "clear-ticket/",
  DELETE_ENTRY: "delete-entry/",
};

export default quickbooksDesktopEndpoints;
